

























































































import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { SwCountryIcon } from '@libs-uuif/shared/sw-country-icon';
import { SwSelect } from '@libs-uuif/shared/sw-select';
import Component from 'vue-class-component';
import { SwModal, SwModalBody, SwModalFooter } from '@sonicwall/unified-ui-framework/src/shared/sw-modal';
import { SwButton } from '@sonicwall/unified-ui-framework/src/shared/sw-button';
import { SwTextfield } from '@sonicwall/unified-ui-framework/src/shared/sw-textfield';
import { SwCheckbox } from '@sonicwall/unified-ui-framework/src/shared/sw-checkbox';
import { Prop } from 'vue-property-decorator';
import { SwForm, SwFormRow,  SwFormRowError } from '@libs-uuif/shared/sw-form';
import { required } from 'vuelidate/lib/validators';

const cssPrefix = 'distributor-info';
@Component({
  components: {
    SwCountryIcon,
    SwSelect,
    SwModal,
    SwModalBody,
    SwModalFooter,
    SwButton,
    SwTextfield,
    SwCheckbox,
    SwForm,
    SwFormRow,
    SwFormRowError,
  },
  validations: {
    distributors: { required },
    customerNumber: { required },
  },
})
export default class DistributorInfo extends SwExtendedVue {
  cssPrefix = cssPrefix;
  display2 = true;
  modalTitle = '';
  isSubmitted : boolean = false;
  customerNumber : any = '';
  @Prop({ required :  true })
  distributorOpt : any;
  @Prop({ required :  true })
  orgID : any;
  distributorOption : any[] = [];
  distributors : any = '';
  created() {
    this.distributorOpt.forEach((ele : any) => {
      const inner : any = {};
      inner['id'] = ele.distyorgid;
      inner['label'] = ele.distyname;
      inner['value'] = ele.distyname;
      this.distributorOption.push(inner);
    });
    this.distributors =  this.distributorOption[0].id;
  }

  closeDialog() {
    this.$emit('close-modal');
  }

  submit() {
    if (this.checkInputValidation()) {
      if (this.customerNumber.trim().length !== '') {
        const displayDistyObj = {
          distyOrgId: this.distributors,
          customerNumber: this.customerNumber,
          partnerOrgId: this.orgID,
          distyOrgName: this.distributorOption.filter((ele : any) => ele.id === this.distributors)[0].value,
        };
        const request = {
          distyOrgId: this.distributors,
          customerNumber: this.customerNumber,
          partnerOrgId: this.orgID,
        };
        this.$store.commit('startLoading');
        this.$store.dispatch('SnbProfileStoreModule/addDistryInfo', request)
        .then((resp) => {
          this.$store.commit('stopLoading');
          if (resp.operationStatus === 'OK') {
            this.$emit('success', displayDistyObj);
            this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: resp.msgDesc });
          } else {
            this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp.msgDesc });
          }
        });
      }
    }
  }

  checkInputValidation(): boolean {
    this.$v!.distributors!.$touch();
    this.$v!.customerNumber!.$touch();
    if (!this.$v!.distributors!.$invalid && !this.$v!.customerNumber!.$invalid &&
        (this.distributors != null && this.distributors !== '') &&
        (this.customerNumber != null && this.customerNumber !== '')) {
      return true;
    }
    return false;
  }

  cancel() {
    this.$emit('close-modal');
  }
}
